/**
 * /app/trusts/$id/resolutions/$rid — Resolution detail (route shell).
 *
 * Screen impl in `./index-screen.tsx`, lazy-loaded via `lazyRouteComponent`. A
 * deep trust sub-route (resolution body + patch/edit + status transitions), not
 * a first-paint route, so the body leaves the entry bundle (200 kB gzip budget).
 * Same shell+screen pattern as the sibling trust tabs. The committed
 * routeTree.gen.ts imports only `Route` from here, so no plugin regen is needed.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/trusts/$id/resolutions/$rid/')({
  component: lazyRouteComponent(() => import('./index-screen'), 'ResolutionDetailScreen'),
});
